document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('section.stories')
	if (!section) return

	const storiesContainer = section.querySelector('.stories-container')
	if (!storiesContainer) return

	const isFullSlider = section.classList.contains('full-slider')
	const mobileBreakpoint = 768
	let carousel = null

	const before = section.querySelector('.before')
	const after = section.querySelector('.after')

	function initSlider() {
		if (isFullSlider) {
			if (!carousel) {
				carousel = new KeenSlider(
					storiesContainer,
					{
						loop: false,
						mode: 'snap',
						slides: {
							perView: 1.15,
							spacing: 24,
							origin: 'center',
						},
						breakpoints: {
							'(min-width: 768px)': {
								slides: {
									perView: 2,
									spacing: 24,
								},
							},
							'(min-width: 1024px)': {
								slides: {
										perView: 2.5,
										spacing: 24,

								},
							},
							'(min-width: 1440px)': {
								slides: {
										perView: 3.08,
										spacing: 24,

								},
							},
						},
					},
					[navigation, slideFocusability]
				)
			}
		} else {
			if (window.innerWidth <= mobileBreakpoint) {
				if (!carousel) {
					carousel = new KeenSlider(storiesContainer, {
						loop: false,
						mode: 'snap',
						slides: {
							perView: 1.25,
							spacing: 24,
							origin: 'center',
						},
					}, [slideFocusability])
				}
			} else {
				if (carousel) {
					carousel.destroy()
					carousel = null
				}
			}
		}
	}

	if (before) {
		before.addEventListener('click', () => {
			carousel?.prev()
		})
	}

	if (after) {
		after.addEventListener('click', () => {
			carousel?.next()
		})
	}

	document.addEventListener('keydown', e => {
		if (!carousel || !section.contains(document.activeElement)) return
		if (e.key === 'ArrowLeft') { e.preventDefault(); carousel.prev() }
		else if (e.key === 'ArrowRight') { e.preventDefault(); carousel.next() }
	})

	initSlider()

	let resizeTimer
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer)
		resizeTimer = setTimeout(() => {
			if (!isFullSlider) {
				initSlider()
			}
		}, 250)
	})
})

function slideFocusability(slider) {
	function update() {
		const slides = slider.container.querySelectorAll('.keen-slider__slide')
		const viewportWidth = window.innerWidth
		slides.forEach(slide => {
			const rect = slide.getBoundingClientRect()
			const isVisible = rect.right > 0 && rect.left < viewportWidth
			const focusables = slide.querySelectorAll('a, button')
			focusables.forEach(el => {
				el.setAttribute('tabindex', isVisible ? '0' : '-1')
			})
		})
	}
	slider.on('created', () => setTimeout(update, 50))
	slider.on('animationEnded', update)
	slider.on('destroyed', () => {
		const focusables = slider.container.querySelectorAll('a, button')
		focusables.forEach(el => el.removeAttribute('tabindex'))
	})
}

function navigation(slider) {
	let wrapper = document.querySelector('.stories .controls')
	if (!wrapper) return
	let dots

	function removeElement(element) {
		element.parentNode.removeChild(element)
	}

	function createDiv(className) {
		var div = document.createElement('div')
		var classNames = className.split(' ')
		classNames.forEach(name => div.classList.add(name))
		return div
	}

	function dotMarkup(remove) {
		if (remove) {
			if (dots) removeElement(dots)
			return
		}
		dots = createDiv('dots')
		slider.track.details.slides.forEach((_e, idx) => {
			var dot = createDiv('dot')
			dot.addEventListener('click', () => {
				idx =
					idx > slider.track.details.maxIdx ? slider.track.details.maxIdx : idx
				slider.moveToIdx(idx)
			})
			dots.appendChild(dot)
		})
		wrapper.appendChild(dots)
	}

	function updateClasses() {
		var slide = slider.track.details.rel
		Array.from(dots.children).forEach(function (dot, idx) {
			if (idx === slide) {
				dot.classList.add('dot--active')
			} else {
				dot.classList.remove('dot--active')
			}
		})
	}

	slider.on('created', () => {
		dotMarkup()
		updateClasses()
	})
	slider.on('optionsChanged', () => {
		dotMarkup(true)
		dotMarkup()
		updateClasses()
	})
	slider.on('slideChanged', () => {
		updateClasses()
	})
	slider.on('destroyed', () => {
		dotMarkup(true)
	})
}